"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.translationsNamespace = exports.defaultTranslations = void 0;
/* istanbul ignore file */

/**
 * DO NOT EDIT!
 * This file was autogenerated by npm script `localizations-codegen`.
 * Changes may cause incorrect behavior and will be lost when the file is regenerated.
 *
 * Run `npx localizations-codegen` to regenerate.
 */

const defaultTranslations = exports.defaultTranslations = {
  addToListDialogMessage: 'Organise your favourite products into lists',
  addToListDialogTitle: 'Manage favourite lists',
  anonymousDialogMessage: 'Save your favourite products and create lists to share with others',
  anonymousDialogTitle: 'Login to create favourite lists',
  cancel: 'Cancel',
  listsWereUpdated: 'Your list/s were updated',
  logIn: 'Log in',
  myFavourites: 'My favourites',
  productWasAddedToTheLists: 'Your list/s were updated',
  productWasRemovedFromTheLists: 'Your list/s were updated',
  register: 'Register',
  save: 'Save'
};
const translationsNamespace = exports.translationsNamespace = 'favorites-heart';
